import { render } from "./TokenPriceChart.vue?vue&type=template&id=2c5fb453"
import script from "./TokenPriceChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenPriceChart.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/TokenPriceChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c5fb453"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c5fb453', __exports__)) {
    api.reload('2c5fb453', __exports__)
  }
  
  module.hot.accept("./TokenPriceChart.vue?vue&type=template&id=2c5fb453", () => {
    api.rerender('2c5fb453', render)
  })

}


export default __exports__